import editingFieldSignal from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/editingFieldSignal';
import {
	type DocumentPanelTarget,
	openDocumentPanel,
} from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/documentPanelSignal';
import { setPendingDiscard } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/pendingDiscardSignal';

/**
 * The single door into opening the document sidebar: a modified draft queues a discard request
 * instead of being silently replaced, so a click in the document, the arrows, « Prochain à vérifier »
 * and every list gesture share the exact same guard rather than each re-deciding it.
 */
const requestDocumentPanel = (target: DocumentPanelTarget): void => {
	if (editingFieldSignal.peek()?.isDirty) {
		setPendingDiscard({ type: 'panel', target });
		return;
	}

	openDocumentPanel(target);
};

export default requestDocumentPanel;
